import React from "react";
import { Button, alpha, useTheme } from "@mui/material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { EmptyState } from "../../../shared/ui";

interface EmptyReportsStateProps {
  hasActiveFilters: boolean;
  onResetFilters: () => void;
}

export const EmptyReportsState: React.FC<EmptyReportsStateProps> = ({
  hasActiveFilters,
  onResetFilters,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={<FolderOpenIcon />}
      title={hasActiveFilters ? "No matching reports found" : "No reports yet"}
      description={
        hasActiveFilters
          ? "Try adjusting your filters or search criteria to find what you're looking for."
          : "Get started by creating your first incident report."
      }
      action={
        hasActiveFilters ? (
          <Button
            variant="outlined"
            onClick={onResetFilters}
            startIcon={<CloseIcon />}
            sx={{ textTransform: "none", px: 3, py: 1 }}
          >
            Clear all filters
          </Button>
        ) : (
          <Button
            variant="contained"
            onClick={() => navigate("/video-selection")}
            startIcon={<AddIcon />}
            size="large"
            sx={{
              textTransform: "none",
              px: 4,
              py: 1.2,
              fontSize: "1rem",
              fontWeight: 600,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 4px 14px 0 ${alpha(theme.palette.primary.main, 0.4)}`,
              "&:hover": {
                boxShadow: `0 6px 20px 0 ${alpha(theme.palette.primary.main, 0.5)}`,
              },
            }}
          >
            Create New Report
          </Button>
        )
      }
    />
  );
};
